import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="0 0 48 48" fill="none"><path fill="#8141EB" fill-rule="evenodd" d="M3.482 7.363c.87 5.07 9.24 10.152 13.315 12.06-2.792 3.32-2.903 10.355 1.2 13.565 3.283 2.568 3.433 5.164 3.182 7.649-2.01-4.913-4.95-6.653-6.839-7.649-.307 1.396.223 3.062.67 3.769-4.488-2.278-8.15-9.686-8.15-12.282.943 1.174 2.093 1.349 2.66 1.435l.103.016c0-1.144-.196-2.624-2.931-5.276-3.01-2.918-4.327-8.82-3.21-13.287ZM30.62 25.715a6.516 6.516 0 1 1-13.033 0 6.516 6.516 0 0 1 13.033 0Zm.49-6.293c4.076-1.907 12.445-6.99 13.316-12.059 1.116 4.466-.2 10.369-3.21 13.287-2.736 2.652-2.931 4.132-2.931 5.276l.102-.016c.568-.086 1.717-.26 2.661-1.436 0 2.596-3.662 10.005-8.15 12.283.446-.707.976-2.373.67-3.769-1.89.996-4.83 2.736-6.84 7.649-.25-2.485-.1-5.08 3.182-7.649 4.104-3.21 3.992-10.244 1.2-13.566Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
